import { Button, ButtonProps } from 'antd';
import { FC, ReactNode } from 'react';

interface ITcButton extends ButtonProps {
  children: ReactNode;
  className?: string;
}

const TcButton: FC<ITcButton> = ({ children, className, ...props }) => {
  return (
    <Button className={`min-w-[150px] ${className}`} {...props}>
      {children}
    </Button>
  );
};

export default TcButton;
